import * as React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../../commonInfra/components/FormikCheckbox';
import { componentRegistryEntry } from '../../../../directives/tbSiteSettingsForServerAdminFormAdapter';
import { SiteInfo, SiteSettingsForServerAdminProps } from '../../ReactSiteSettingsForServerAdmin';
import { SettingsSection } from '../../SettingsSection';
import { RevisionHistoryClearButton } from './RevisionHistoryClearButton';
import { RevisionHistoryOptions } from './RevisionHistoryOptions';

export const VERSION_HISTORY_ENABLED_FIELD = 'settings.versionHistoryEnabled';
export type RevisionHistorySectionProps = SiteSettingsForServerAdminProps<
  'versionHistoryEnabled'
  | 'contentVersionLimitEnabled'
  | 'contentVersionLimit'
  | 'flowsOnSiteEnabled'
  >
  & SiteInfo;

export function RevisionHistorySection(props: RevisionHistorySectionProps) {
  return (
    <SettingsSection title={Messages.versionHistorySettingsGroupName()}
                     description={Messages.versionHistorySettingsMsg()}>

      <FormikCheckbox name={VERSION_HISTORY_ENABLED_FIELD}
                      label={Messages.versionHistorySettingsCheckboxLabel()}
                      testId={'allow-version-history-checkbox'}>
        <RevisionHistoryOptions {...props}/>
      </FormikCheckbox>

      <RevisionHistoryClearButton {...props} />
    </SettingsSection>
  );
}

export const RevisionHistorySectionSpecs = componentRegistryEntry({
  name: 'RevisionHistorySection',
  component: RevisionHistorySection
});
